export default __webpack_public_path__ + "9bada2df9c07d9e0765c7c7dba9c3b73.svg";